import { Directive } from '@angular/core';

@Directive({
    selector: '[toolbar-title], toolbar-title, [toolbarTitle]',
    standalone: true,
    host: { class: 'toolbar-title' },
})
export class ToolbarTitleDirective
{
}
